import React, { Component } from 'react';
import {Link} from 'react-router-dom';

export default class Logo extends Component {
    render = () =>
    <a className="navbar-brand custom-mr" href="/">
      <img src="/images/hdfc_logo.png" alt="hdfc-logo" width="122" height="60" />
    </a>
}
